import { render, staticRenderFns } from "./BookmarkCard.vue?vue&type=template&id=2b083f66&scoped=true"
import script from "./BookmarkCard.vue?vue&type=script&lang=js"
export * from "./BookmarkCard.vue?vue&type=script&lang=js"
import style0 from "./BookmarkCard.vue?vue&type=style&index=0&id=2b083f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b083f66",
  null
  
)

export default component.exports